import {
  ENotificationType as ENotificationTypeConfirm,
  fetchAnnouncementsRelevanceConfirm as confirmActual,
} from '../../../shared/repositories/moderation-announcements-relevance/v3/announcements-relevance-confirm';
import {
  ENotificationType as ENotificationTypeConfirmNotActual,
  fetchAnnouncementsRelevanceConfirmNotActual as confirmNotActual,
} from '../../../shared/repositories/moderation-announcements-relevance/v3/announcements-relevance-confirm-not-actual';
import { getHttpApi } from '@cian/http-api/browser';

export const getOptions = (
  guid: string,
  notificationType: ENotificationTypeConfirm | ENotificationTypeConfirmNotActual,
) => ({
  httpApi: getHttpApi(),
  parameters: {
    guid,
    notificationType,
  },
});

export function confirmActualAnnouncement(
  guid: string,
  notificationType: ENotificationTypeConfirm | ENotificationTypeConfirmNotActual,
) {
  const options = getOptions(guid, notificationType);

  return confirmActual(options);
}

export function confirmNotActualAnnouncement(
  guid: string,
  notificationType: ENotificationTypeConfirm | ENotificationTypeConfirmNotActual,
) {
  const options = getOptions(guid, notificationType);

  return confirmNotActual(options);
}
